import React from 'react';
import { Wrapper, TextWrapper, Title, Description, Savings } from './elements';
import ToolTip01 from 'dc/ToolTip01';
import Cnt10 from 'dc/Cnt10';

type ChaDSc1Props = {
  readonly className?: string;
  readonly value: number;
  readonly inactive: boolean;
  readonly onClick?: () => void;
  readonly title: string;
  readonly description: string;
  readonly tooltip: string;
  readonly icon?: string;
  readonly iconColor?: string;
  readonly locale: string;
  readonly decimals?: number;
};

export default function ChaDSc1({
  className,
  value,
  inactive,
  title,
  description,
  tooltip,
  icon,
  onClick,
  iconColor,
  decimals,
  locale,
}: ChaDSc1Props) {
  return (
    <Wrapper className={className}>
      <TextWrapper>
        <Title $inactive={inactive}>{title}</Title>
        <Description $inactive={inactive}>{description}</Description>
      </TextWrapper>
      <ToolTip01 text={tooltip}>
        <Savings
          $inactive={inactive}
          icon={icon || 'icon-leaf'}
          onClick={inactive ? null : onClick}
          color={iconColor}
        >
          {typeof value === 'number' ? (
            <Cnt10 decimals={decimals} animate locale={locale}>
              {value}
            </Cnt10>
          ) : (
            value
          )}
        </Savings>
      </ToolTip01>
    </Wrapper>
  );
}
